import bounty from 'bounty/lib/bounty';
import classnames from 'classnames';
import { PropTypes } from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { accountBalanceRequest } from '../../../modules/account/actions';
import { getTotalBalance, isBalancePending } from '../../../modules/account/selectors';

export class Balance extends Component {
  constructor(props) {
    super(props);
    this.balanceRef = null;
    this.cancelBounty = null;
  }

  componentDidMount() {
    this.props.refreshBalance();

    const { balance } = this.props;
    if (this.cancelBounty) {
      this.cancelBounty();
    }
    if (balance !== null && balance.match(/\d/) && this.balanceRef) {
      this.cancelBounty = bounty({
        el: this.balanceRef,
        value: `£${balance}`,
        initialValue: `£${balance}`,
        lineHeight: 1,
        letterSpacing: -1,
        easing: () => 1
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { balance } = this.props;
    const prevBalance = prevProps.balance;
    const initial = (prevBalance !== null && prevBalance.match(/\d/)) ? prevBalance : '0.00';
    let easing;
    if (prevBalance === balance) {
      return;
    }
    if (initial === balance && balance === '0.00') {
      easing = () => 1;
    }
    if (this.cancelBounty) {
      this.cancelBounty();
    }
    if (balance !== null && balance.match(/\d/) && this.balanceRef) {
      this.cancelBounty = bounty({
        el: this.balanceRef,
        value: `£${balance}`,
        initialValue: `£${initial}`,
        lineHeight: 1,
        letterSpacing: -1,
        easing
      });
    }
  }

  componentWillUnmount() {
    if (this.cancelBounty) {
      this.cancelBounty();
    }
  }

  render() {
    const { balance, pending, refreshBalance } = this.props;

    if (balance === '') {
      return (<div />);
    }

    const pendingClass = classnames('balance__content', {
      'balance__content--pending': pending
    });

    return (
      <div className="balance" onClick={refreshBalance}>
        <div className={pendingClass}>
          <i className="balance__icon icon icon--refresh" />
          {
            (balance === null)
              ? '£N/A'
              : (
                <span
                  className="balance__value"
                  ref={ref => {
                    this.balanceRef = ref;
                  }}
                />
              )
          }
        </div>
      </div>
    );
  }
}

Balance.propTypes = {
  balance: PropTypes.string,
  pending: PropTypes.bool,
  refreshBalance: PropTypes.func.isRequired
};

const mapDispatchToProps = {
  refreshBalance: () => accountBalanceRequest(false)
};

const mapStateToProps = (state) => ({
  balance: getTotalBalance(state),
  pending: isBalancePending(state)
});

export default connect(mapStateToProps, mapDispatchToProps)(Balance);
